export default "__VITE_ASSET__BtWZHj9l__"